import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import HolidayPackages from './pages/HolidayPackages';
import TripItinerary from './pages/TripItinerary';
import TripBooking from './components/TripBooking';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import CustomPackage from './components/CustomPackage';
import ModalPopup from './components/ModalPopup';

function App() {
  return (
    <Router>
      <ModalPopup/>
      <ScrollToTop/>
      <div className="app-container">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/CustomPackage" element={<CustomPackage/>} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/holiday-packages" element={<HolidayPackages />} />
            <Route path="/trip-itinerary/:title" element={<TripItinerary />} />
            <Route path="/trip-booking/:title" element={<TripBooking />} />

          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
